module.exports = __webpack_public_path__ + "static/media/support.5e4ae02b.svg";